import React from "react";
import { Img } from "../../Img";
export const PaymentMethodsIcons = ({ title, icons, note }) => (React.createElement("div", { className: "payment-methods-icons" },
    React.createElement("h6", { className: "payment-methods-icons__title" }, title),
    React.createElement("ul", { className: "payment-methods-icons__icons-list" }, icons.map((icon, index) => (React.createElement("li", { key: index, className: "payment-methods-icons__item" },
        React.createElement(Img, { src: icon.methodIconURL, alt: icon.methodIconAlt }))))),
    note && (React.createElement("div", { className: "payment-methods-icons__note", dangerouslySetInnerHTML: {
            __html: note,
        } }))));
